var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _path, _rect31, _rect32, _rect33, _rect34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSorting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.375,
    y: 33.0469,
    width: 1.32812,
    height: 2.73438,
    rx: 0.664062,
    fill: "#145DB6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.32812,
    height: 2.73438,
    rx: 0.664062,
    transform: "matrix(-1 0 0 1 56.0156 40)",
    fill: "#145DB6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.32812,
    height: 2.73438,
    rx: 0.664062,
    transform: "matrix(-1 0 0 1 56.0156 36.0938)",
    fill: "#145DB6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.32812,
    height: 2.73438,
    rx: 0.664062,
    transform: "matrix(-1 0 0 1 56.0156 44.2188)",
    fill: "#145DB6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.32812,
    height: 2.73438,
    rx: 0.664062,
    transform: "matrix(-1 0 0 1 56.0156 48.2812)",
    fill: "#145DB6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.32812,
    height: 2.73438,
    rx: 0.664062,
    transform: "matrix(0 1 1 0 51.1719 51.0938)",
    fill: "#145DB6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1406,
    y: 40,
    width: 1.32812,
    height: 2.73438,
    rx: 0.664062,
    fill: "#145DB6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1406,
    y: 36.0938,
    width: 1.32812,
    height: 2.73438,
    rx: 0.664062,
    fill: "#145DB6"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 39.375,
    y: 37.2656,
    width: 1.32812,
    height: 2.73438,
    rx: 0.664062,
    fill: "#145DB6"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 39.2969,
    y: 33.125,
    width: 1.32812,
    height: 2.73438,
    rx: 0.664062,
    fill: "#145DB6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 29.208,
    y: 32.0288,
    width: 1.32812,
    height: 8.59375,
    rx: 0.664062,
    transform: "rotate(-117.561 29.208 32.0288)",
    fill: "#145DB6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1.32812,
    height: 8.59375,
    rx: 0.664062,
    transform: "matrix(0.462688 -0.886521 -0.886521 -0.462688 50.6655 31.8726)",
    fill: "#145DB6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1406,
    y: 44.2188,
    width: 1.32812,
    height: 2.73438,
    rx: 0.664062,
    fill: "#145DB6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1406,
    y: 48.2812,
    width: 1.32812,
    height: 2.73438,
    rx: 0.664062,
    fill: "#145DB6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9844,
    y: 51.0938,
    width: 1.32812,
    height: 2.73438,
    rx: 0.664062,
    transform: "rotate(90 28.9844 51.0938)",
    fill: "#145DB6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9844,
    y: 51.0938,
    width: 1.32812,
    height: 2.73438,
    rx: 0.664062,
    transform: "rotate(90 28.9844 51.0938)",
    fill: "#145DB6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22.8125,
    width: 9.6875,
    height: 13.75,
    rx: 3,
    fill: "#F0C419"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1094,
    y: 24.4531,
    width: 5.54688,
    height: 1.40625,
    rx: 0.703125,
    fill: "#F3D55B"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1094,
    y: 27.1875,
    width: 5.54688,
    height: 1.40625,
    rx: 0.703125,
    fill: "#F3D55B"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1094,
    y: 30.0781,
    width: 5.54688,
    height: 1.40625,
    rx: 0.703125,
    fill: "#F3D55B"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1094,
    y: 33.0469,
    width: 5.54688,
    height: 1.40625,
    rx: 0.703125,
    fill: "#F3D55B"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0781,
    y: 20,
    width: 9.6875,
    height: 13.75,
    rx: 3,
    fill: "#3B97D3"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 37.1875,
    y: 21.6406,
    width: 5.54688,
    height: 1.40625,
    rx: 0.703125,
    fill: "#90BAE1"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 37.1875,
    y: 24.375,
    width: 5.54688,
    height: 1.40625,
    rx: 0.703125,
    fill: "#90BAE1"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 37.1875,
    y: 27.2656,
    width: 5.54688,
    height: 1.40625,
    rx: 0.703125,
    fill: "#90BAE1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 37.1875,
    y: 30.2344,
    width: 5.54688,
    height: 1.40625,
    rx: 0.703125,
    fill: "#90BAE1"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3125,
    y: 22.7344,
    width: 9.6875,
    height: 13.75,
    rx: 3,
    fill: "#FF5364"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 52.4219,
    y: 24.375,
    width: 5.54688,
    height: 1.40625,
    rx: 0.703125,
    fill: "#FB7B76"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 52.4219,
    y: 27.1094,
    width: 5.54688,
    height: 1.40625,
    rx: 0.703125,
    fill: "#FB7B76"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 52.4219,
    y: 30,
    width: 5.54688,
    height: 1.40625,
    rx: 0.703125,
    fill: "#FB7B76"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 52.4219,
    y: 32.9688,
    width: 5.54688,
    height: 1.40625,
    rx: 0.703125,
    fill: "#FB7B76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4531 39.9639L27.8906 42.3077V58.4795C27.8906 59.542 29.1146 59.8337 29.7266 59.8467H50C50.875 59.503 51.1719 58.5837 51.2109 58.167V43.7139C51.2422 42.5264 50.4167 42.1254 50 42.0733H39.9609C38.7109 42.1045 38.3724 41.6696 38.3594 41.4483L37.2266 39.9639C36.7891 39.2452 36.1328 39.2478 35.8594 39.3389H31.0156C29.9531 39.2452 29.5312 39.7165 29.4531 39.9639Z",
    fill: "#67B9CC"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5469,
    y: 44.375,
    width: 15,
    height: 2.73438,
    rx: 1.36719,
    fill: "#41767F"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5469,
    y: 50.625,
    width: 11.0156,
    height: 1.48438,
    rx: 0.742188,
    fill: "#41767F"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5469,
    y: 56.0938,
    width: 18.5938,
    height: 1.48438,
    rx: 0.742188,
    fill: "#41767F"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5469,
    y: 53.2031,
    width: 6.25,
    height: 1.48438,
    rx: 0.742188,
    fill: "#41767F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/sorting.3e8d3636649ccf0c90a4a5773027229f.svg";
export { ForwardRef as ReactComponent };